import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Suspense, useState, type PropsWithChildren } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { ChannelProvider } from "~/contexts/channel";
import { queryConfig } from "~/lib/react-query";
import { AppHeader } from "./app-header";
import { MainErrorFallback } from "./errors/main";
import { Toaster } from "./ui/sonner";
import { Spinner } from "./ui/spinner";

const VITE_CHANNEL_CODE = import.meta.env.VITE_CHANNEL_CODE;

if (!VITE_CHANNEL_CODE) {
  throw new Error(
    "VITE_CHANNEL_CODE is not defined in the environment variables",
  );
}

export const AppProvider = ({ children }: PropsWithChildren) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: queryConfig,
      }),
  );

  return (
    <Suspense fallback={<AppFallback />}>
      <ErrorBoundary FallbackComponent={MainErrorFallback}>
        <QueryClientProvider client={queryClient}>
          <ChannelProvider code={VITE_CHANNEL_CODE}>
            <AppHeader />
            {children}
            <Toaster richColors />
          </ChannelProvider>
        </QueryClientProvider>
      </ErrorBoundary>
    </Suspense>
  );
};

function AppFallback() {
  return (
    <div className="flex h-screen w-screen items-center justify-center">
      <Spinner />
    </div>
  );
}
